import { GridColumn } from '@grid/abstractions';
import { sortDefaultOrderValue } from './sort-default-order-value';

export function sortColumn(current: GridColumn, next: GridColumn): 1 | -1 | 0 {
  sortDefaultOrderValue(current);
  sortDefaultOrderValue(next);

  if (current.filterableColumn!.order! > next.filterableColumn!.order!) {
    return -1;
  } else if (current.filterableColumn!.order! < next.filterableColumn!.order!) {
    return 1;
  }
  return 0;
}
